import { useState } from 'react'

/** Who one email goes to. */
export type EmailRecipients = { to: string[]; cc: string[] }

/** The request fields for a send: present only when staff changed who it goes to. */
export type EmailRecipientsOverride = { to_emails?: string[]; cc_emails?: string[] }

/**
 * Who an action item's email goes to and who it copies, changed for this one email before it is sent
 * (USA-1663). `defaults` is who it would go to anyway; the override is empty until staff change it, so a
 * send without a change keeps the server's choice.
 */
export function useEmailRecipients(defaults: EmailRecipients | undefined) {
  const [changed, setChanged] = useState<EmailRecipients | null>(null)
  return {
    recipients: changed ?? defaults,
    changed: changed !== null,
    change: setChanged,
    reset: () => setChanged(null),
    override: (changed ? { to_emails: changed.to, cc_emails: changed.cc } : {}) as EmailRecipientsOverride,
  }
}

export type EmailRecipientsState = ReturnType<typeof useEmailRecipients>
